import Event = createjs.Event;

/**
 * Mainly used for social login, ported from Actionscript
 */
export class Poker2PreloadEvent extends Event {
    public static CONNECTION_FAILD: string = "connectionFaild";

    public static VERSION_CONTROLL_SECONDFRAME: string = "versionCheckSecondFrame";
    public static VERSION_CONTROLL_FAILD: String = "versionCheckFaild";

    public static SOCIAL_LOGIN_AVATARCREATION: string = "avatarcreation";
    public static SOCIAL_LOGIN_SECONDFRAME: string = "socialLoginSecondFrame";
    public static SOCIAL_LOGIN_FAILD: string = "socialLoginFaild";

    public static ADD_AVATAR_DATA: string = "avatarData";

    public static SOCIAL_AVATAR_CREATION_SUCCESSFUL: string = "socialAvatarCreationSuccessful";

    public static SOCIAL_AVATAR_NAME_SUGGESTIONS: string = "socialavatarnamesuggestions";
    public static SOCIAL_AVATAR_NAME_SELECTED: string = "socialavatarnameselected";
    public static SOCIAL_REGISTER_FAILD: string = "socialRagisterFaild";

    public params: any[];
    public secoundFrameState: string;

    public constructor(type: string, secoundFrameState: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.secoundFrameState = secoundFrameState;
        this.params = params;
    }
}
